import { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { Tooltip } from 'reactstrap';
import * as React from 'react';
import './Help.css';

interface State {
    isOpen: boolean;
}

interface Props {
    id: string;
}

class Help extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    render(): JSX.Element {
        const { isOpen } = this.state;
        const { id } = this.props;

        return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <FontAwesome
                    name={'question-circle'}
                    className="pl-1 help"
                    id={id}
                />
                <Tooltip
                    placement="top"
                    isOpen={isOpen}
                    target={id}
                    toggle={() => { this.setState({isOpen: !this.state.isOpen}); }}
                >
                    {this.props.children}
                </Tooltip>
            </div>
        );
    }
}

export default Help;